import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Paragraph from '../Paragraph/Paragraph';
import themeColors from '../../assets/styles/themeColors';
import { selectApplicationError } from '../../store/selectors/applicationSelectors';
import { selectUserError } from '../../store/selectors/userSelectors';
import { createApplicationError } from '../../store/actions/application/applicationActions';
import { createUserError } from '../../store/actions/user/userActions';

const ApplicationError = () => {
  const dispatch = useDispatch();
  const applicationError = useSelector(selectApplicationError);
  const userError = useSelector(selectUserError);
  const error = applicationError || userError;

  /** Drops any error left over from an earlier wizard step so it doesn't render on an unrelated page. */
  useEffect(() => {
    dispatch(createApplicationError(''));
    dispatch(createUserError(''));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!error) {
    return null;
  }

  return <Paragraph color={themeColors.colorErrorMessage}>{error}</Paragraph>;
};

export default ApplicationError;
